import DOMPurify from 'dompurify';

export const normalizeSafeUrl = (url = '') => {
  const trimmed = String(url).trim();
  if (!trimmed) return '';
  if (/^(https?:|mailto:|data:image\/)/i.test(trimmed)) return trimmed;
  if (/^(#|\/|\.\/)/.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

export const sanitizeHtml = html => DOMPurify.sanitize(String(html || ''));
